export default "__VITE_ASSET__UjXjqZWF__"